import React, { useEffect, useRef, useState } from 'react'
import { Button, Checkbox } from 'antd'
import { useTranslation } from "react-i18next"
import { useGameplayConfig } from 'store'
import PermissionsModal from 'components/dumb/PermissionsModal'
import { PERMISSION_DEVICE_TYPES } from 'constants/globalConstants'
import { useScreenRecordingContext } from 'store'
import analytics from 'services/config/analytics'

export const ScreenShareTest = ({
    handleScreenTestSuccess,
    privacyPolicyLink,
    setConsent,
    consent,
}) => {
    const [isTestSuccess, setIsTestSuccess] = useState(false)
    const streamRef = useRef(null)
    const { t } = useTranslation()
    const { isVideoProctored, isProctored } = useGameplayConfig()
    const { isPermissionModalVisible, initialiseAndStartRecording } = useScreenRecordingContext()

    const handleStart = async () => {
        try {
            const stream = await initialiseAndStartRecording()
            if (stream) {
                analytics.track('screen_share_started')
                streamRef.current = stream
                if ((isVideoProctored || isProctored) && consent) {
                    handleScreenTestSuccess()
                } else {
                    setIsTestSuccess(true)
                }
            }
        } catch (err) {
            analytics.track('screen_share_denied', { error: err?.name || String(err) })
            console.log(err)
        }
    }

    useEffect(() => {
        if (consent && streamRef.current) {
            handleScreenTestSuccess()
        }
    }, [consent, streamRef.current])

    return (
        <div className="audio-test-div">
            <div className="flex items-center">
                <p className="size-30 color-primary font-medium weight-500">
                    {t("permissions.screen_test.heading")}
                </p>
            </div>
            <div className="mt-10 mb-20">
                <p className="color-primary size-16 weight-500 mb-0">{t("permissions.screen_test.title")}</p>
                <p className="color-primary opacity-70 size-16 weight-400">{t("permissions.screen_test.subtext")}</p>
            </div>
            {
                isTestSuccess
                    ? <div className="flex items-center mb-20">
                        <Checkbox
                            checked={consent}
                            onChange={(e) => setConsent(e.target.checked)}
                            className="mr-10 bottom-10"
                        />
                        <p className="size-18 color-secondary m-2">
                            {t("webcam.agree_to_privacy_policy")}
                            <a
                                className="size-18 font-bold color-primary"
                                href={privacyPolicyLink}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {' '}
                                {t("webcam.privacy_policy")}
                            </a>
                            .
                        </p>
                    </div>
                    : <Button
                        type="primary"
                        className="br-20 width-150 size-14"
                        onClick={handleStart}
                    >
                        Start Sharing
                    </Button>
            }
            <PermissionsModal
                visible={!!isPermissionModalVisible}
                type={isPermissionModalVisible}
                device={PERMISSION_DEVICE_TYPES.SCREEN}
                handleOnConfirm={handleStart}
            />
        </div>
    )
}

